<script>

import { Overlay } from '../../'

export default {
    name: 'KAMA',
    mixins: [Overlay],
    methods: {
        meta_info() {
            return {
                author: 'StdSquad', version: '1.0.0',
                desc: 'Kaufman Adaptive Moving Average - Adapts to market volatility',
                preset: {
                    name: 'KAMA $length',
                    side: 'onchart',
                    settings: {
                        lineWidth: 0.75,
                        color: '#607d8b'
                    }
                }
            }
        },
        use_for() { return ['KAMA'] },
        calc() {
            return {
                props: {
                    length: { def: 14, text: 'Length' },
                    fast: { def: 2, text: 'Fast EMA' },
                    slow: { def: 30, text: 'Slow EMA' }
                },
                conf: { renderer: 'Spline' },
                update: `
                    let change = Math.abs(close[0] - close[length])
                    let moves = ts(Math.abs(close[0] - close[1]))
                    let volatility = sum(moves, length)[0]
                    let efficiency = volatility > 0 ? change / volatility : 0
                    let fastAlpha = 2 / (fast + 1), slowAlpha = 2 / (slow + 1)
                    let alpha = Math.pow(efficiency * (fastAlpha - slowAlpha) + slowAlpha, 2)
                    let average = ts(NaN)
                    average[0] = Number.isFinite(average[1]) && Number.isFinite(alpha) ? average[1] + alpha * (close[0] - average[1]) : close[0]
                    return average[0]
                `
            }
        }
    }
}
</script>
